import { useUserContext } from '@/Contexts/Authenticated/UserContext';
import useProvidedContext from '@/Hooks/UseProvidedContext';
import React, { ReactNode, createContext, useEffect, useMemo } from 'react';
import { IWorklistsDashboardStore, WorklistsDashboardStore } from './WorklistsDashboardStore';

export const WorklistsDashboardStoreContext = createContext<IWorklistsDashboardStore | null>(null);

export function WorklistsDashboardStoreContextProvider({ children }: Readonly<{ children: ReactNode }>): React.ReactElement {
    const userContextData = useUserContext();
    const store = useMemo<WorklistsDashboardStore>(() => new WorklistsDashboardStore(), [userContextData]); // Whenever the user changes, the dashboard changes as well

    useEffect(() => {
        store.initialize()
            .catch((err) => {
                console.log(`❌ Failed to initialize the worklists dashboard store`);
                console.log(err);
                throw err;
            });

        return () => {
            store.destroy();
        };
    }, [store]);

    return (
        <WorklistsDashboardStoreContext.Provider value={store}>
            {children}
        </WorklistsDashboardStoreContext.Provider>
    );
}

export const useWorklistsDashboardStoreContext = (): IWorklistsDashboardStore => {
    return useProvidedContext(WorklistsDashboardStoreContext);
};
